import type { FC, ReactNode } from 'react'
import React from 'react'
import styled from 'styled-components'

import { OutcomeStatus } from '@/lib/apollo/model/outcome'

type Props = {
  label: ReactNode
  outcomeStatus?: OutcomeStatus
  onSetOutcome: (outcomeStatus: OutcomeStatus) => void
}

const AutomaticPassWrapper = styled.div`
  grid-column-start: 2;
  white-space: nowrap;
`

const InputWrapper = styled.div`
  grid-column-start: 3;
`

export const FieldRow = styled.div`
  display: grid;
  grid-template-columns: 1fr min-content min-content;
  column-gap: 10px;
  margin-bottom: 10px;
`

const OverrideOutcomeStatusFieldRowToggle: FC<Props> = ({
  label,
  outcomeStatus,
  onSetOutcome,
}) => (
  <FieldRow>
    <div>{label}</div>
    {outcomeStatus === OutcomeStatus.pass && (
      <AutomaticPassWrapper>Automatic pass</AutomaticPassWrapper>
    )}
    <InputWrapper>
      <input
        type="checkbox"
        checked={
          outcomeStatus === OutcomeStatus.pass || outcomeStatus === OutcomeStatus.accepted
        }
        disabled={outcomeStatus === OutcomeStatus.pass}
        onChange={e => {
          const overallOutcome = e.target.checked
            ? OutcomeStatus.accepted
            : OutcomeStatus.fail
          onSetOutcome(overallOutcome)
        }}
      />
    </InputWrapper>
  </FieldRow>
)

export default OverrideOutcomeStatusFieldRowToggle
